import React from 'react'

function MyTrips() {
  return (
    <div>MyTrips</div>
  )
}

export default MyTrips;